export enum RequestType {
  Document = 'document',
  ChangeRequest = 'change_request',
  // Task = "task",
}
